var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#939393",
    stroke: "#939393",
    strokeWidth: 0.3,
    d: "M19.794 5.65H6.956a2.21 2.21 0 0 0-2.207 2.206v3.189H2.632a.631.631 0 1 0 0 1.263h2.117v1.697H3.693a.63.63 0 1 0 0 1.263h1.056v.825A2.21 2.21 0 0 0 6.956 18.3h12.838A2.21 2.21 0 0 0 22 16.093V7.856c0-1.216-.99-2.206-2.206-2.206zM6.956 6.913h12.838c.224 0 .43.08.592.21l-6.132 4.5c-.518.38-1.24.38-1.758 0l-6.132-4.5a.945.945 0 0 1 .592-.21zm13.78 9.18c0 .52-.422.943-.942.943H6.956a.944.944 0 0 1-.943-.943v-.825h2.379a.632.632 0 0 0 0-1.263h-2.38V8.433l5.736 4.208a2.745 2.745 0 0 0 1.627.527c.573 0 1.148-.175 1.626-.527l5.736-4.208v7.66z"
  })));
};
export default SvgMail;